<template>
  <v-card>
    <v-card-title style="align-items: center">
      Confirm to mark this booking {{ action }}?
      <v-spacer />
      <v-btn icon @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col class="d-flex justify-space-around">
          <v-btn @click="close">Back</v-btn>
          <v-btn @click="cancel">Cancel</v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { readTimeTables } from '@/api/timetable';
import api from '@/api';
import { cancelBooking } from '@/api/bookings';

export default {
  name: 'CancelBookingDialog',

  props: {
    //timetable id
    id: String,
    action: String,
  },
  data() {
    return {
      model: null,
    };
  },
  watch: {
    id: {
      immediate: true,
      handler(v) {
        if (v) {
          this.reload();
        }
      },
    },
  },
  methods: {
    async cancel() {
      try {
        await cancelBooking(api, this.model.booking);
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: 'Booking cancelled',
          type: 'success',
          color: 'success',
        });
        this.valueProxy = false;
        this.$emit('cancel', this.id);
        this.$emit('close');
      } catch (e) {
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: e,
        });
      }
    },
    close() {
      this.$emit('close');
    },
    async reload() {
      this.model = await readTimeTables(api, this.id);
    },
  },
};
</script>

<style scoped></style>
